__turbopack_context__.v({
  "TredList": "search-module__QFsvpa__TredList",
  "TredListSec": "search-module__QFsvpa__TredListSec",
  "active": "search-module__QFsvpa__active",
  "filterSec": "search-module__QFsvpa__filterSec",
  "loaderSearch": "search-module__QFsvpa__loaderSearch",
  "notfound": "search-module__QFsvpa__notfound",
  "searchBar": "search-module__QFsvpa__searchBar",
  "searchBarIcon": "search-module__QFsvpa__searchBarIcon",
  "searchBnr": "search-module__QFsvpa__searchBnr",
  "searchloader": "search-module__QFsvpa__searchloader",
  "trendingSearch": "search-module__QFsvpa__trendingSearch",
  "zoomFadeIn": "search-module__QFsvpa__zoomFadeIn",
});
